import { compose } from 'redux';

import { COMMON_DATETIME_FORMAT } from 'constants/date';
import { FieldType } from 'constants/formGenerator';
import { getConditionalArray } from 'utils/data';
import { fillConfigFieldsWithKeys } from 'utils/loanManagement';

const generalFormFields = {
  earliestClosingDate: {
    fieldId: 'earliestClosingDate',
    type: FieldType.DATE,
    nameInModel: 'earliestClosingDate',
    inputProps: {
      label: 'Earliest Closing Date',
      disabled: true,
      required: false,
      variant: 'outlined',
      format: COMMON_DATETIME_FORMAT,
    },
  },
  manuallyUnderwritten: {
    fieldId: 'manuallyUnderwritten',
    type: FieldType.CHECKBOX,
    nameInModel: 'manuallyUnderwritten',
    inputProps: {
      label: 'Manually Underwritten',
      disabled: false,
    },
  },
};

export const getGeneralConfig = compose(fillConfigFieldsWithKeys, ({ isEcdHidden }) => ({
  groups: [
    {
      type: FieldType.GROUP,
      fieldsClassName: 'flex items-center flex-wrap',
      fields: [
        ...getConditionalArray(!isEcdHidden, [generalFormFields.earliestClosingDate]),
        generalFormFields.manuallyUnderwritten,
      ],
    },
  ],
}));
